import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  AuthenticationRoutes,
  EmployeeRoutes,
  ManagerRoutes,
} from "./AppRoutes";
import LayoutEmployee from "../layouts/LayoutEmployee";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {AuthenticationRoutes.map(
          ({ path, auth, element: Component, ...value }, key) => (
            <Route key={key} path={path} element={Component} />
          )
        )}

        {EmployeeRoutes.map(
          ({ path, auth, element: Component, ...value }, key) => {
            return auth && auth === true ? (
              <Route key={key} path="/" element={<LayoutEmployee />}>
                <Route exact key={key} path={path} element={Component} />
              </Route>
            ) : (
              <Route key={key} path="/" element={<LayoutEmployee />}>
                <Route exact key={key} path={path} element={Component} />
              </Route>
            );
          }
        )}
        {ManagerRoutes.map(
          ({ path, auth, element: Component, ...value }, key) => {
            return auth === true ? (
              <Route key={key} path="/" element={<LayoutEmployee />}>
                <Route exact key={key} path={path} element={Component} />
              </Route>
            ) : (
              <Route key={key} path="/" element={<LayoutEmployee />}>
                <Route exact key={key} path={path} element={Component} />
              </Route>
            );
          }
        )}
      </Routes>
    </Router>
  );
};

export default AppRouter;
